export default __webpack_public_path__ + "static/media/abebekebede-testimonial-1.93a3da48.png";